import React from "react";

import "./App.css";

import Tootle from "./component/Tootle";
import Navbar from "./component/Navbar";
import Home from "./component/Home";
import About from "./component/About";
import LibraryPdf from "./component/LibraryPdf";
import LibraryPdfUpload from "./Admin/LibraryPdfUpload"
import LibraryAudio from "./component/LibraryAudio";
import IslamicServiceMosque from "./component/IslamicServiceMosque";
import Department from "./component/Department";
import DarulIfta from "./component/DarulIfta";
import Donation from "./component/Donation";
import Contact from "./component/Contact";
import ComingSoon from "./component/ComingSoon";
import "./component/theme.css";
import "./component/typography.css";
import "./component/animation.css";
import "./component/responsive.css";

import { HashRouter as Router, Routes, Route } from "react-router-dom";

import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function App() {
  return (
    <Router>
      <Tootle />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/library/pdf" element={<LibraryPdf />} />
        <Route path="/library/audio" element={<LibraryAudio />} />
        <Route path="/islamicservice/mosque" element={<IslamicServiceMosque />} />
        <Route path="/department" element={<Department />} />
        <Route path="/misbahidarul-ifta" element={<DarulIfta />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/LibraryPdfUpload" element={<LibraryPdfUpload />} />
        <Route path="/Comingsoon" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
}

export default App;
